export default {
  type: 'user',
  fields: {
    avatar_url: 'string',
    full_name: 'string',
    updated_at: 'date',
  },
};
